import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import {selectAuthState, selectProfile, selectSubMenu} from '../features/auth/authSlice'

export const useAuth = () => {
    const authState = useSelector(selectAuthState);
    const profile = useSelector(selectProfile);
    const submenu = useSelector(selectSubMenu);

    return useMemo(() => ({ authState, profile, submenu }), [authState])
}


